import {
  assoc,
  compose,
  dec,
  defaultTo,
  flatten,
  isNil,
  length,
  map,
  modify,
  pluck,
  reject
} from 'ramda';
import { isNilOrEmpty } from '../../../../server/helpers/index.mjs';

const useBeneficiariesRefund = ({
  grantees,
  form,
  isValid,
  setTabs,
  append,
  remove,
  fields,
  setManualTrigger
}) => {
  const granteeDefaultValue = {
    id: null,
    bankAccounts: [
      {
        ownerName: '',
        iban: '',
        bic: '',
        bankName: ''
      }
    ]
  };

  const handleAddBeneficiary = () => {
    if (form.formState.isValid) {
      append(granteeDefaultValue);
      setTabs(assoc('selectedTab', length(fields) + 1));
    } else {
      form.trigger();
    }
  };

  const handleRemoveBeneficiary = (idx) => {
    remove(idx);
    setManualTrigger(idx);
    setTabs(modify('selectedTab', dec));
  };

  const numberOfGrantees = length(grantees);

  const numberOfBankAccounts = compose(
    length,
    reject(isNilOrEmpty),
    map(reject(isNil)),
    flatten,
    defaultTo([]),
    pluck('bankAccounts')
  )(fields);
  const displayAddButton = numberOfBankAccounts < numberOfGrantees;

  return {
    handleAddBeneficiary,
    handleRemoveBeneficiary,
    isValid,
    displayAddButton
  };
};

export default useBeneficiariesRefund;
